import React from 'react'
import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'
import { ComplianceType } from '../../quality-check-scheme-detail/constants'

const PreviewCompliance = ({ qcPlanDetail }: { qcPlanDetail: AIQualityCheckPlanDetailItem | null }) => {
  return (
    <div style={{ paddingLeft: 10, paddingTop: 10 }}>
      <div style={{ display: 'flex' }}>
        <span>
          板块:合规板块
        </span>
      </div>
      {qcPlanDetail?.items?.map((item, index) => (
        <div key={index} className="rule-container">
          <span style={{ marginRight: '10px', marginTop: '6px' }}>
            <span>
              规则{index + 1}:{item?.name}
            </span>
          </span>
          <div style={{ display: 'inline-block', width: 'calc(100% - 10px)' }}>
            <ul style={{ paddingLeft: 10 }}>
              {item?.subItems?.map((subItem, subIndex) => (
                <li key={subIndex} style={{ display: 'flex' }}>
                  <span style={{ width: 10 }}>*</span>
                  <span>
                    {subItem?.description}
                    <span>({subItem?.complianceType === ComplianceType.violation ? '违规' : '豁免'})</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  )
}

export default PreviewCompliance
